/** Form validation only; the API remains authoritative for saved pricing. */
export const validOverrideCents = (dollars: number | null, minimumCents = 0): number | undefined => {
  if (dollars === null || !Number.isFinite(dollars)) {
    return undefined
  }
  const cents = Math.round(dollars * 100)
  if (!Number.isSafeInteger(cents) || cents < Math.max(0, minimumCents)) {
    return undefined
  }
  return cents
}
